import { render } from "./Title.vue?vue&type=template&id=324db140&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=324db140&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-324db140"

export default script